module.exports = __webpack_public_path__ + "static/img/blank.6d55a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blank.png
// module id = cE4L
// module chunks = 1